export enum RefundPolicy {
  Flexible = "flexible",
  Limited = "limited",
}

export interface RefundPolicyType {
  name: string;
  description: string;
  creditDescription?: string;
}

export function getRefundPolicy(refundPolicyType: any) {
  if (refundPolicyType === RefundPolicy.Flexible) {
    return RefundPolicies.flexible;
  }
  return RefundPolicies.limited;
}

// MUST BE KEPT IN SYNC WITH `useActivityString` in ui-components-website
export const RefundPolicies: Record<
  RefundPolicy.Limited | RefundPolicy.Flexible,
  RefundPolicyType
> = {
  [RefundPolicy.Limited]: {
    name: "Standard",
    description:
      "Refund within 24 hours of payment until your next meeting or lesson access begins.",
    creditDescription:
      "Cancel within 24 hours of enrolling to have credits returned to your credit balance. If the class starts within 24 hours, cancel before the class begins.",
  },
  [RefundPolicy.Flexible]: {
    name: "Flexible",
    description:
      "Full refund until the class begins, or within 24 hours of purchase (until class starts), then a pro-rated refund based on the number of meetings.",
  },
};

const types = {
  LIMITED: RefundPolicy.Limited,
  FLEXIBLE: RefundPolicy.Flexible,
};

export const REFUND_POLICY_TYPES = Object.freeze(types);
